import React from "react";
import { Phone, Mail } from "lucide-react";

const ContactInfo = () => (
  <div className="space-y-10">
    <div>
      <div className="flex items-center gap-3 text-razmek-gold mb-2">
        <Phone size={16} strokeWidth={1.5} />
        <span className="eyebrow text-razmek-gold">WhatsApp</span>
      </div>
      <a
        href="https://wa.me/5215583570588"
        className="font-serif text-2xl text-razmek-dark link-underline"
      >
        +52 1 55 8357 0588
      </a>
    </div>
    <div>
      <div className="flex items-center gap-3 text-razmek-gold mb-2">
        <Mail size={16} strokeWidth={1.5} />
        <span className="eyebrow text-razmek-gold">Correo</span>
      </div>
      <a
        href="mailto:contacto@razmek.com"
        className="font-serif text-2xl text-razmek-dark link-underline"
      >
        contacto@razmek.com
      </a>
    </div>
    <div className="border-t border-razmek pt-8">
      <div className="eyebrow text-razmek-gray">Atención</div>
      <p className="font-sans text-base text-razmek-dark mt-2">
        Lunes a viernes
        <br />
        09:00 — 19:00
      </p>
    </div>
  </div>
);

export default ContactInfo;
